import { render, staticRenderFns } from "./StockOrderTable.vue?vue&type=template&id=08a9999d&scoped=true"
import script from "./StockOrderTable.vue?vue&type=script&lang=ts"
export * from "./StockOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./StockOrderTable.vue?vue&type=style&index=0&id=08a9999d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a9999d",
  null
  
)

export default component.exports